import apiClient from './client';

export interface SubscriptionStatus {
  isActive: boolean;
  subscriptionStatus: string;
  isTrial: boolean;
  trialEndsAt: string | null;
  gracePeriodEndsAt: string | null;
  periodEnd: string | null;
}

export async function getSubscriptionStatus(): Promise<SubscriptionStatus> {
  const { data } = await apiClient.get<SubscriptionStatus>('/subscription');
  return data;
}
